var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThunder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1708 0.941603C10.5454 1.0597 10.8002 1.40714 10.8002 1.79997V6.29997L14.4002 6.29997C14.7358 6.29997 15.0435 6.48668 15.1985 6.78434C15.3535 7.082 15.33 7.44116 15.1375 7.71608L8.83751 16.7161C8.61224 17.0379 8.20427 17.1764 7.82962 17.0583C7.45497 16.9402 7.2002 16.5928 7.2002 16.2L7.2002 11.7H3.6002C3.26461 11.7 2.9569 11.5133 2.80192 11.2156C2.64694 10.9179 2.67044 10.5588 2.86289 10.2839L9.16289 1.28385C9.38816 0.962038 9.79612 0.823505 10.1708 0.941603Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunder);
export default __webpack_public_path__ + "static/media/thunder.662b9945b375d4757c1df2db1f20c594.svg";
export { ForwardRef as ReactComponent };